export function usdToEth(usd: string, ethPriceInUsd: string): string {

    const result = Number(usd) / Number(ethPriceInUsd);

    return result.toFixed(8);
}
